import { FunctionComponent, useEffect, useState } from 'react'

import { IFind } from 'shared/modules/termosUso/domain/usecases/Find'
import Steps from 'shared/components/Steps'
import { IStepsData } from 'shared/components/Steps/StepsComponent.types'

import { IVerifyPhoneAndCnpj } from '../../domain/usecases/VerifyPhoneAndCnpjImpl'
import { ISendPin } from '../../domain/usecases/SendPinImpl'
import { IValidateEmail } from '../../domain/usecases/ValidateEmailImpl'
import { IVerifyPin } from '../../domain/usecases/VerifyPinImpl'
import { IValidateEmailByCode } from '../../domain/usecases/ValidateEmailByCodeImpl'

import Email from './components/Email'
import EmailConfirm from './components/EmailConfirm'
import Phone from './components/Phone'
import Photo from './components/Photo'
import Terms from './components/Terms'
import { Container } from './styles'
import NewPassword from './components/NewPassword'
import { IChangeGestor } from 'modules/user/domain/usecases/ChangeGestorImpl'
import { useAuth } from 'modules/auth/hooks/auth'

type TProps = {
  validateEmail: IValidateEmail
  validateEmailByCode: IValidateEmailByCode
  sendPin: ISendPin
  verifyPin: IVerifyPin
  changeGestorImpl: IChangeGestor
  findTerms: IFind
  verifyPhoneAndCnpj: IVerifyPhoneAndCnpj
}

export const steps = {
  Terms: 0,
  Email: 1,
  EmailConfirm: 2,
  Phone: 3,
  Photo: 4,
  NewPassword: 5,
}

const ChangeGestor: FunctionComponent<TProps> = ({
  validateEmail,
  validateEmailByCode,
  sendPin,
  verifyPin,
  changeGestorImpl,
  findTerms,
  verifyPhoneAndCnpj,
}) => {
  const { signOut } = useAuth()

  const [selectedStep, setSelectedStep] = useState(steps.Terms)

  useEffect(() => {
    signOut()
  }, [])

  const components: IStepsData[] = [
    {
      component: (
        <Terms
          key="terms"
          setSelectedStep={setSelectedStep}
          findTerms={findTerms}
        />
      ),
    },
    {
      component: (
        <Email
          key="email"
          setSelectedStep={setSelectedStep}
          validateEmail={validateEmail}
        />
      ),
    },
    {
      component: (
        <EmailConfirm
          validateEmailByCode={validateEmailByCode}
          setSelectedStep={setSelectedStep}
          validateEmail={validateEmail}
        />
      ),
    },
    {
      component: (
        <Phone
          key="phone"
          setSelectedStep={setSelectedStep}
          sendPin={sendPin}
          verifyPhoneAndCnpj={verifyPhoneAndCnpj}
          verifyPin={verifyPin}
        />
      ),
    },
    {
      component: <Photo key="photo" setSelectedStep={setSelectedStep} />,
    },
    {
      component: (
        <NewPassword
          key="password"
          setSelectedStep={setSelectedStep}
          changeGestorImpl={changeGestorImpl}
        />
      ),
    },
  ]

  return (
    <Container key="signUpKey">{components[selectedStep]?.component}</Container>
  )
}

export default ChangeGestor
